<template>
  <v-flex xs12 sm10 md8 lg6>
    <v-card class="pa-4">
      <v-flex xs12 pb-3 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pb-3 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-form v-model="valid">
        <v-layout row wrap justify-space-between align-center>
          <v-flex xs12>
            <v-autocomplete
              :items="companies"
              v-if="!isLocalAdmin"
              :label="$lang.actions.selectCompany"
              v-model="paymentServer.companyId"
              item-text="name"
              item-value="id"
              required
              :readonly="isEdit"
              :loading="companyLoading"
              :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="$lang.labels.paymentServerName"
              v-model="paymentServer.name"
              required
              :rules="[v => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12 pb-1>
            <v-autocomplete
              chips
              deletable-chips
              multiple
              :items="mappedTerminals"
              :label="$lang.actions.selectTerminals"
              v-model="paymentServer.paymentTerminals"
              required
              :disabled="mappedTerminals.length === 0"
              :loading="terminalsLoading"
              :rules="[() => paymentServer.paymentTerminals.length > 0 || `${$lang.errors.missingTerminals}`]"
            />
          </v-flex>
          <v-flex xs12 v-if="isEdit">
            <v-textarea
              id="key"
              :label="$lang.labels.key"
              v-model="paymentServer.key"
              auto-grow
              rows="1"
              :readonly="isEdit"
            />
          </v-flex>
          <v-flex xs12 v-if="isEdit">
            <v-btn
              class="primary mr-3 ml-0"
              @click="changeStatus()">
              {{ paymentServer.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-space-between class="mt-3 px-2">
          <v-text-field
            v-if="isEdit && createdOn"
            :label="$lang.labels.created"
            v-model="createdOn"
            readonly
            class="min-w max-w mx-3"
          />
          <v-text-field
            v-if="isEdit && modifiedOn"
            :label="$lang.labels.modified"
            v-model="modifiedOn"
            readonly
            class="min-w max-w mx-3"
          />
        </v-layout>
        <v-layout row wrap justify-space-between align-content-center class="mt-3">
          <v-btn
            flat class="ml-0"
            @click="$router.push({ name: 'paymentServers' })">
            <v-icon>keyboard_arrow_left</v-icon>
            {{$lang.actions.close}}
          </v-btn>
          <div>
            <v-btn class="primary" v-if="isEdit" @click="copyKey">
              {{$lang.actions.copyKey}}
            </v-btn>
            <v-btn
              class="primary mx-0"
              :disabled="!valid"
              @click="submit">
              {{ isEdit ? $lang.actions.update : $lang.actions.create}}
            </v-btn>
          </div>
        </v-layout>
      </v-form>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from "luxon";

  export default {
    data: () => ({
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      terminalsLoading: false,
      companies: [],
      terminals: [],
      paymentServer: {
        companyId: null,
        name: null,
        paymentTerminals: [],
        status: '',
        id: '',
      },
      createdOn: '',
      modifiedOn: '',
      isLocalAdmin: false,
    }),
    watch: {
      'paymentServer.companyId': function (val) {
        this.fetchTerminals(val);
      },
      err(val) {
        if (val !== '') {
          setTimeout(() => {
            this.err = '';
          }, 5000);
        }
      },
    },
    computed: {
      mappedTerminals() {
        return this.terminals.map(terminal => ({
          text: `${terminal.name} (${terminal.status})`,
          value: terminal.id,
        }));
      },
    },
    methods: {
      changeStatus() {
        const action = this.paymentServer.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`paymentserver/${action}/${this.paymentServer.id}?companyId=${localStorage.selectedPaymentServer}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.$set(this.paymentServer, 'status', action === 'activate' ? 'active' : 'inactive');
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      init() {
        const roles = JSON.parse(this.$cookie.get('roles') || '[]');
        this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
        return new Promise((resolve) => {
          this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                if (this.isLocalAdmin && this.companies.length === 1) this.paymentServer.companyId = this.companies[0].id;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      copyKey() {
        try {
          var copyText = document.getElementById('key');
          copyText.select();
          const success = document.execCommand('copy');
        } catch (e) {
          console.log(e);
        }
      },
      fetchTerminals(id) {
        this.terminalsLoading = true;
        this.terminals = [];
        this.$http.get(`paymentterminal/list?companyId=${id}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.terminalsLoading = false;
              this.terminals = res.body.terminals;
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      submit() {
        let url = this.isEdit ? `paymentserver/update/${this.$route.params.id}` : 'paymentserver/create';
        delete this.paymentServer.createdOn;
        this.$http.post(url, this.paymentServer)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = this.isEdit ? 'Payment Server updated successfully' : 'Payment Server created successfully';
              setTimeout(() => {
                if (this.isEdit) {
                  this.success = '';
                } else {
                  this.$router.push({name: 'paymentServers'});
                }
              }, 3000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.init()
        .then(() => {
          if (this.$route.params.id) {
            this.isEdit = true;
            this.$http.get(`paymentserver/${this.$route.params.id}?companyId=${localStorage.selectedPaymentServer}`)
              .then((res) => {
                if (res.body.status === 'Success') {
                  this.paymentServer = res.body.server;
                  this.createdOn = this.formatDate(this.paymentServer.createdOn);
                  if (this.paymentServer.modifiedOn) {
                    this.modifiedOn = this.formatDate(this.paymentServer.modifiedOn);
                  }
                  return;
                }
                this.err = res.body.statusText
              }, (err) => {
                this.err = err.body.statusText || err.body.message;
              })
          }
        })
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// PaymentServerDetails.vue?8ff206b6